import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom'

import './style/App.scss'
import Header from './components/Header';
import Footer from './components/Footer';

import Home from './components/Home';
import Project from './components/Project';
import Editor from './components/Editor';

import NatusProject from './components/NatusProject';
import RuinedCityProject from './components/RuinedCityProject';
import Maintenance from './components/Maintenance';

//import requireAuthentication from './utils/authUtil'

class App extends Component {
  render() {
    const pathname = window.location.pathname
    return (
      <div className="App">
        {/* { !pathname.includes('project') ? <Header /> : '' } */}
        <Switch>
          <Route exact path="/" component={Maintenance} />
          <Route exact path="/project/natus-engine" component={NatusProject} />
          <Route exact path="/project/ruined-city" component={RuinedCityProject} />
          <Route path="**" component={Maintenance} />
          {/* <Route exact path="/" component={Home} />
          <Route exact path="/project/:id" component={Project} />
          <Route exact path="/editor" component={requireAuthentication(Editor)} />
          <Route path="**" component={Home} /> */}
        </Switch>
        { pathname.includes('project') ? <Footer /> : '' }
        {/* <Footer /> */}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js